// extracted by mini-css-extract-plugin
module.exports = {"colorGreyDark":"#333","colorGreyDark2":"#777","colorGreyDark3":"#999"};